// NOTE: legacy uses redux-immutable which forces the whole redux state tree to be immutable
// the session reducer is immutable to be compatable with it --
// branching behavior here is to see if top-level state is immutable & handle if so for legacy

export const infoIsLoading = (state) =>
  state.getIn ? state.getIn(['session', 'infoIsLoading']) : state.session.getIn(['infoIsLoading']);

export const infoIsLoaded = (state) =>
  state.getIn ? state.getIn(['session', 'infoIsLoaded']) : state.session.getIn(['infoIsLoaded']);

export const human = (state) =>
  state.getIn ? state.getIn(['session', 'info', 'human']) : state.session.getIn(['info', 'human']);

export const loggedIn = (state) =>
  state.getIn
    ? state.getIn(['session', 'info', 'logged_in'], false)
    : state.session.getIn(['info', 'logged_in'], false);

export const loginRequestStatus = (state) =>
  state.getIn
    ? state.getIn(['session', 'loginRequestStatus']).toJSON()
    : state.session.getIn(['loginRequestStatus']).toJSON();

export const registrationRequestStatus = (state) =>
  state.getIn
    ? state.getIn(['session', 'registrationRequestStatus']).toJSON()
    : state.session.getIn(['registrationRequestStatus']).toJSON();

export const serverLoginRedirect = (state) =>
  state.getIn
    ? state.getIn(['session', 'serverLoginRedirect'])
    : state.session.getIn(['serverLoginRedirect']);

export const email = (state) =>
  state.getIn ? state.getIn(['session', 'email']) : state.session.getIn(['email']);

export const hasGeneratedPassword = (state) =>
  state.getIn
    ? state.getIn(['session', 'hasGeneratedPassword'])
    : state.session.getIn(['hasGeneratedPassword']);

export const isNewHuman = (state) =>
  state.getIn ? state.getIn(['session', 'isNewHuman']) : state.session.getIn(['isNewHuman']);

export const humanStatusRequestStatus = (state) =>
  state.getIn
    ? state.getIn(['session', 'humanStatusRequestStatus']).toJSON()
    : state.session.getIn(['humanStatusRequestStatus']).toJSON();

export const resetPasswordRequestStatus = (state) =>
  state.getIn
    ? state.getIn(['session', 'resetPasswordRequestStatus']).toJSON()
    : state.session.getIn(['resetPasswordRequestStatus']).toJSON();
